'use client';

interface CreatingContentBannerProps {
  isVisible: boolean;
  kind?: string; // e.g. 'post', 'comment', 'reply'
}

export const CreatingContentBanner = ({ isVisible, kind = 'post' }: CreatingContentBannerProps) => {
  if (!isVisible) return null;

  const label = kind || 'post';

  return (
    <div
      className="fixed top-20 left-1/2 z-[999] w-full max-w-md -translate-x-1/2 rounded-lg bg-amber-50/95 px-4 py-3 shadow-xl border border-amber-200 animate-in slide-in-from-top-3 duration-200"
      aria-live="polite"
      role="alert">
      <p className="text-center font-semibold text-amber-900">{`Creating your ${label}.`}</p>
      <p className="text-center text-sm text-amber-800">Don&apos;t leave or refresh this page.</p>
    </div>
  );
};
